export default __webpack_public_path__ + "static/media/frame_ja_sp.8ae4944d.png";